module.exports = __webpack_public_path__ + "img/seierstad_Bokhandleren_i_Kabul4.af72ef6f.jpg";